import React, { Component } from 'react'
import { Provider } from 'react-redux'
import route from '../route'
import { Router } from 'react-router-dom'
import history from '../route/history'

export default class Root extends Component {
    render() {
        const { store } = this.props
        window.appHistory = history
        if (!this.route) this.route = route
        return (
            <Provider store={store}>
                <Router children={this.route} history={history} />
            </Provider>
        )
    }
}
